import type { AuthState } from '../types';

export const InitState: AuthState = {
  user: null,
  status: 'idle',
  pendingVerification: null,
};
